/* 🤖 this file was generated by svg-to-ts*/
export const icoWarningFilled: {
  name: 'warning-filled';
  data: string;
} = {
  name: 'warning-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.884 3.504l9 16.105C22.236 20.24 21.754 21 21 21H3c-.754 0-1.236-.76-.884-1.39l9-16.106c.376-.672 1.392-.672 1.768 0zM12 16a1 1 0 100 2 1 1 0 000-2zm0-7a1 1 0 00-.993.883L11 10v4a1 1 0 001.993.117L13 14v-4a1 1 0 00-1-1z" fill="#909090"/></svg>`
};
